module.exports = __webpack_public_path__ + "img/201703-birthday-1024x1024.b4cc0db2.jpeg";